import { FloorAcl } from '@era/locations-sdk';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export type FloorAclState = EntityState<FloorAcl>;

export function selectAclIdFromResourceId(floor: FloorAcl) {
  return floor.resourceId;
}

export const adapter: EntityAdapter<FloorAcl> = createEntityAdapter<FloorAcl>({
  selectId: selectAclIdFromResourceId,
});

export const initialState: FloorAclState = adapter.getInitialState();
